import React, { useCallback, useEffect } from 'react'
import {
  //   Card,
  Typography,
  Grid,
  Box,
  LinearProgress,
  Chip,
  // ToggleButton,
  // ToggleButtonGroup,
  //   useMediaQuery,
  useTheme,
  IconButton,
} from '@mui/material'
import useCustomStyles from '../../../../../utils/hooks/CustomStylesHook'
import {
  DATE_DIRECTIONS,
  GRAPH_PERIODS,
  safeRangeKeys,
  VITAL_KEYS,
} from '../Constant'
import dayjs from 'dayjs'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { getVitalTracking } from '../../../../../services/DeviceServices'
import { useAppSelector } from '../../../../../app/hooks'
import { selectPatientData } from '../../../OpdPatientSlice'
import { selectSafeRanges } from '../DeviceSlice'

const styles = (theme: any) => ({
  root: {
    padding: theme.spacing(2),
  },
  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  section: {
    borderRadius: '8px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  label: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  progressBar: {
    height: 10,
    borderRadius: 5,
    // backgroundColor: '#444',
  },
  chip: {
    fontSize: '0.75rem',
    color: '#fff',
  },
  bar: {
    backgroundColor: '#183f7c',
  },
  toggleGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
  toggleBtn: {
    fontSize: '14px',
    fontWeight: 600,
    minWidth: '60px',
  },
  dateDisplay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
  },
})

const SleepTracking: React.FC = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  //   const isMobile = useMediaQuery('(max-width:600px)')
  const safeRanges = useAppSelector(selectSafeRanges)

  const [period] = React.useState(GRAPH_PERIODS.DAY)
  const [currentDate, setCurrentDate] = React.useState(dayjs())
  const [chartData, setChartData] = React.useState<any>({})
  const patient = useAppSelector(selectPatientData)

  const calculateProgress = (duration: string, total: string): number => {
    const parseTime = (timeStr: string): number => {
      const hoursMatch = timeStr?.match(/(\d+)\s*hr/)
      const minsMatch = timeStr?.match(/(\d+)\s*min/)

      const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0
      const mins = minsMatch ? parseInt(minsMatch[1], 10) : 0

      return hours * 60 + mins
    }

    const durationInMinutes = parseTime(duration)
    const totalInMinutes = parseTime(total)

    if (totalInMinutes === 0) return 0

    const progress = (durationInMinutes / totalInMinutes) * 100
    console.log(Math.min(100, Math.round(progress)))
    return Math.min(100, Math.round(progress))
  }

  const sleepData = [
    {
      label: 'Sleep Duration',
      status: '',
      statusColor: '#d4a017',
      value: `${chartData?.totalSleepHours || ''}`,
      progress: calculateProgress(
        chartData?.totalSleepHours,
        `${safeRanges?.[safeRangeKeys?.SLEEP]?.max} hr 0 min`
      ),
    },
    {
      label: 'Time in Bed',
      status: '',
      statusColor: '#d32f2f',
      value: `${chartData?.totalBedHours || ''}`,
      progress: calculateProgress(
        chartData?.totalBedHours,
        `${safeRanges?.[safeRangeKeys?.SLEEP]?.max} hr 0 min`
      ),
    },
    {
      label: 'Deep Sleep',
      status: '',
      statusColor: '#388e3c',
      value: `${chartData?.deepSleepHours || ''}`,
      progress: calculateProgress(
        chartData?.deepSleepHours,
        `${safeRanges?.[safeRangeKeys?.SLEEP]?.max} hr 0 min`
      ),
    },
    {
      label: 'Light Sleep',
      status: '',
      statusColor: '#388e3c',
      value: `${chartData?.lightSleepHours || ''}`,
      progress: calculateProgress(
        chartData?.lightSleepHours,
        `${safeRanges?.[safeRangeKeys?.SLEEP]?.max} hr 0 min`
      ),
    },
    {
      label: 'Rem Sleep',
      status: '',
      statusColor: '#388e3c',
      value: `${chartData?.remSleepHours || ''}`,
      progress: calculateProgress(
        chartData?.remSleepHours,
        `${safeRanges?.[safeRangeKeys?.SLEEP]?.max} hr 0 min`
      ),
    },
    {
      label: 'Awake Time',
      status: '',
      statusColor: '#d32f2f',
      value: `${chartData?.awakeTimeHours || ''}`,
      progress: calculateProgress(
        chartData?.awakeTimeHours,
        `${safeRanges?.[safeRangeKeys?.SLEEP]?.max} hr 0 min`
      ),
    },
  ]

  // const handlePeriodChange = (
  //   event: React.MouseEvent<HTMLElement>,
  //   newPeriod: string | null
  // ) => {
  //   if (newPeriod !== null) {
  //     setPeriod(newPeriod)
  //   }
  // }

  const changeDate = (direction: string) => {
    const amount =
      period === GRAPH_PERIODS?.DAY
        ? 1
        : period === GRAPH_PERIODS?.WEEK
        ? 7
        : 30
    setCurrentDate((prev) =>
      prev.add(direction === DATE_DIRECTIONS?.NEXT ? amount : -amount, 'day')
    )
  }

  const handleGetSleepTracking = useCallback(async () => {
    const response = await getVitalTracking(
      patient?.muhId,
      currentDate.format('YYYY-MM-DD'),
      VITAL_KEYS?.SLEEP_TRACKING
    )
    if (response?.success) {
      setChartData(response?.data)
    }
  }, [patient?.muhId, currentDate])

  useEffect(() => {
    handleGetSleepTracking()
  }, [handleGetSleepTracking])

  return (
    <Box className={classes?.root}>
      {/* <Typography variant={isMobile ? 'h5' : 'h4'} className={classes?.header}>
        Sleep
      </Typography> */}
      <Box className={classes?.toggleGroup}>
        {/* <ToggleButtonGroup
          value={period}
          exclusive
          onChange={handlePeriodChange}
          color='primary'
          size='small'
        >
          <ToggleButton value='day' className={classes?.toggleBtn}>
            D
          </ToggleButton>
          <ToggleButton value='week' className={classes?.toggleBtn}>
            W
          </ToggleButton>
          <ToggleButton value='month' className={classes?.toggleBtn}>
            M
          </ToggleButton>
        </ToggleButtonGroup> */}
        <Box className={classes?.dateDisplay}>
          <IconButton
            onClick={() => changeDate(DATE_DIRECTIONS?.PREVIOUS)}
            color='inherit'
          >
            <ChevronLeft />
          </IconButton>
          <Typography>
            {currentDate?.format(
              period === GRAPH_PERIODS?.DAY
                ? 'MMM DD, YYYY'
                : period === GRAPH_PERIODS?.WEEK
                ? '[Week of] MMM DD, YYYY'
                : 'MMM YYYY'
            )}
          </Typography>
          <IconButton
            onClick={() => changeDate(DATE_DIRECTIONS?.NEXT)}
            color='inherit'
            disabled={
              currentDate.isSame(dayjs(), 'day') ||
              currentDate.isAfter(dayjs(), 'day')
            }
          >
            <ChevronRight />
          </IconButton>
        </Box>
      </Box>
      <Box
        display={'flex'}
        justifyContent={'center'}
        fontSize={'13px'}
        fontWeight={500}
      >
        {chartData?.mainStartDateTime
          ? dayjs(chartData?.mainStartDateTime).format('MMMM D, YYYY h:mm A')
          : '-'}
        {' - '}
        {chartData?.mainEndDateTime
          ? dayjs(chartData?.mainEndDateTime).format('MMMM D, YYYY h:mm A')
          : '-'}
      </Box>

      <Box className={classes?.section}>
        <Typography variant='h6' pb={2}>
          Sleep Overview
        </Typography>
        <Grid container spacing={2}>
          {sleepData?.map((item, index) => (
            <Grid item xs={12} key={index}>
              <Box className={classes?.label}>
                <Typography>{item?.label}</Typography>
                {item?.status && (
                  <Chip
                    label={item?.status}
                    size='small'
                    style={{ backgroundColor: item?.statusColor }}
                    className={classes?.chip}
                  />
                )}
              </Box>
              <LinearProgress
                variant='determinate'
                value={item.progress}
                classes={{ root: classes?.progressBar, bar: classes?.bar }}
              />
              <Typography align='right' style={{ marginTop: 4 }}>
                {item?.value}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}

export default SleepTracking
